import React, {memo} from 'react';

import MoRunning from '@assets/animations/mo/moRunning.json';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {Box, Typography} from '@mui/material';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';

import {CSpinner} from '@/constants/SpinnerConstants';
import './styles';

const KycStepLoader = () => {
  const {t} = useTranslation();
  return (
    <Box className="kyc-step-loader">
      <Box className="kyc-step-loader-content">
        <Box className="kyc-step-loader-progress">
          <Box className="kyc-step-loader-user">
            <PersonOutlineIcon sx={{fontSize: 32}} />
          </Box>

          <Lottie
            className="kyc-step-loader-lottie"
            animationData={CSpinner.ELLIPSE_PATH}
            loop
            autoplay
          />

          <Box
            component="img"
            src="/assets/images/logo/modak-circle-logo.svg"
            alt="Modak logo"
            className="kyc-step-loader-modak-logo"
          />
        </Box>

        <Typography className="kyc-step-loader-message">
          {t('kyc.kyc_step_loader.message')}
        </Typography>
      </Box>

      <Lottie
        className="kyc-step-loader-mo-running"
        animationData={MoRunning}
        loop
        autoplay
      />
    </Box>
  );
};

KycStepLoader.displayName = 'KycStepLoader';

export default memo(KycStepLoader);
